import Vue from "vue";
import App from "./app/App.vue";
import vuetify from "./app/plugins/vuetify";

new Vue({
  vuetify,
  render: h => h(App)
}).$mount("#app");
